import { AssignFeedsModal } from "./AssignFeedsModal";

export default AssignFeedsModal;
